module.exports = __webpack_public_path__ + "img/banner_desk.75303907.jpg";